import React, { useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Grid,
  makeStyles,
  Container,
  CardHeader,
  CardContent,
  Divider,
  MenuItem,
  InputLabel,
  TextField,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useNavigate } from 'react-router-dom';
import { trackPromise } from 'react-promise-tracker';
import MaterialTable from "material-table";
import authService from '../../../utils/permissionAuth';
import { useAlert } from "react-alert";
import tokenService from '../../../utils/tokenDecoder';
import { LoadingComponent } from '../../../utils/newLoader';
import PageHeader from 'src/views/Common/PageHeader';
import { Autocomplete } from '@material-ui/lab';
import { CustomMultiSelect } from 'src/utils/CustomMultiSelect';
import CloseIcon from '@material-ui/icons/Close';
import { red } from '@material-ui/core/colors';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  deleteIcon: {
    color: red[500],
    '&:hover': {
      color: red[700],
    }
  }

}));

const screenCode = 'SUPPLIERSKUMAPPING';
export default function SupplierSKUMappingAddEdit() {
  const classes = useStyles();
  const alert = useAlert();
  const navigate = useNavigate();
  const [groupArray, setGroupArray] = useState([]);
  const [suppliersForName, setSuppliersForName] = useState();
  const [budgetCodes, setBudgetCodes] = useState();
  const [skuCategory, setSKUCategory] = useState();
  const [sku, setSku] = useState();
  const [factories, setFactories] = useState();
  const [suppliersAuto, setSuppliersAuto] = useState([]);
  const [skuArray, setSkuArray] = useState([]);
  const [SupplierSKUMappingData, setSupplierSKUMappingData] = useState([]);
  const [formData, setFormdata] = useState({
    groupID: 0,
    factoryID: 0,
    supplierID: 0,
    budgetcodeID: 0,
    skuCategoryID: 0,
    skuMasterID: [],
  })
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openDeleteDialog1, setOpenDeleteDialog1] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [selectedOptions, setSelectedOptions] = useState([]);
  const getOptionLabel = option => `${option.label}`;
  const getOptionDisabled = option => option.value === "foo";
  const handleToggleOption = selectedOptions =>
    setSelectedOptions(selectedOptions);
  const handleClearOptions = () => setSelectedOptions([]);
  const handleSelectAll = isSelected => {
    if (isSelected) {
      setSelectedOptions(skuArray);
    } else {
      handleClearOptions();
    }
  };
  const handleClick = () => {
    navigate('/app/SupplierSkuMapping/listing');
  }

  const valuesArray = selectedOptions.map(option => option.value);
  useEffect(() => {
    setFormdata({ ...formData, skuMasterID: valuesArray })
  }, [selectedOptions])

  const handleConfirmDelete = () => {
    if (selectedIndex !== null) {
      const updatedData = [...SupplierSKUMappingData];
      updatedData.splice(selectedIndex, 1);
      setSupplierSKUMappingData(updatedData);
      alert.success("Data removed successfully");
    }
    setOpenDeleteDialog(false);
  };

  const handleCancelDelete = () => {
    setOpenDeleteDialog(false);
  };

  useEffect(() => {
    trackPromise(
      getPermission()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      getGroupsForDropdown()
    );
  }, [])

  useEffect(() => {
    trackPromise(
      getFactoriesByGroupID()
    )
  }, [formData.groupID]);


  useEffect(() => {
    if (formData.groupID > 0) {
      trackPromise(
        getSupplierForDropDownForName(),
        getBudgetCodesForDropDown(),
      );
    };
    setSuppliersForName([]);
    setSKUCategory([]);
    setSelectedOptions([]);
    setFormdata({
      ...formData,
      supplierID: 0,
      budgetcodeID: 0,
      skuCategoryID: 0,
      skuMasterID: [],
    });
  }, [formData.groupID]);


  useEffect(() => {
    if (formData.groupID != 0 && formData.factoryID != 0) {
      trackPromise(
        getSkuCategoryForDropDown(formData.groupID, formData.factoryID, formData.budgetcodeID)
      );
    } else {
      setFormdata(prev => ({
        ...prev,
        skUCategoryID: 0
      }));
      setSKUCategory([]);
    }
  }, [formData.groupID, formData.factoryID, formData.budgetcodeID])


  useEffect(() => {
    if (formData.groupID > 0) {
      trackPromise(
        getSKUForDropdown()
      )
    };
  }, [formData.groupID, formData.budgetcodeID, formData.skuCategoryID]);

  useEffect(() => {
    if (formData.factoryID !== 0) {
      trackPromise(getSuppliersForDropDownAuto());
    }
  }, [formData.factoryID]);


  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITSUPPLIERSKUMAPPING');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setFormdata({
      ...formData,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupArray(groups);
  }

  async function getFactoriesByGroupID() {
    const fac = await services.getFactoriesByGroupID(formData.groupID);
    setFactories(fac);
  }

  async function getFactoriesByGroupID() {
    const fac = await services.getFactoriesByGroupID(formData.groupID);
    setFactories(fac);
  }

  async function getSuppliersForDropDownAuto() {
    const supplierResult = await services.getSuppliersForDropDownAuto(
      formData.factoryID
    );
    setSuppliersAuto(supplierResult);
  }

  async function getSupplierForDropDownForName() {
    const supplier = await services.GetSupplierForDropdownForName(formData.groupID);

    setSuppliersForName(supplier);
  }

  async function getBudgetCodesForDropDown() {
    const budgetCode = await services.GetBudgetCodeForDropdown();
    setBudgetCodes(budgetCode);
  }

  async function getSkuCategoryForDropDown() {
    const SKUCategoryNames = await services.GetSKUCategoryNamesByID(formData.budgetcodeID, formData.groupID, formData.factoryID);
    setSKUCategory(SKUCategoryNames);
  }

  async function getSKUForDropdown() {
    const sku = await services.GetSKUNamesByCategoryID(formData.skuCategoryID);
    const validSkuEntries = Object.entries(sku).filter(([key, value]) => key && value);
    const newSkuArray = validSkuEntries.map(([key, value]) => ({
      value: key,
      label: value
    }));
    setSku(sku);
    setSkuArray(newSkuArray);
    setSelectedOptions([]);
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setFormdata({
      ...formData,
      [e.target.name]: parseInt(value)
    });
  }

  function handleSearchDropdownChangeFieldsSupplier(data, e) {
    if (data === undefined || data === null) {
      setFormdata({
        ...formData,
        supplierID: '0'
      });
      return;
    } else {
      var valueV = data["supplierID"];
      setFormdata({
        ...formData,
        supplierID: valueV
      });
    }
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items
  }
  async function handleAdd() {
    const selectedSKUs = Array.isArray(formData.skuMasterID) ? formData.skuMasterID : [];
    const newMappings = [];
    const existingSkus = new Set();

    for (const skuID of selectedSKUs) {
      const skuIDNum = parseInt(skuID);

      const skuModel = {
        supplierID: parseInt(formData.supplierID),
        skuMasterID: skuIDNum,
      };
      const response = await services.GetExistingSupplierMappingDetails(skuModel);
      if (response.data != null && response.data.supplierSKUMappingID > 0) {
        existingSkus.add(skuID);
        continue;
      }
      const isLocalDuplicate = SupplierSKUMappingData.some(item =>
        parseInt(item.supplierID) === parseInt(formData.supplierID) &&
        parseInt(item.skuMasterID) === skuIDNum
      );

      if (isLocalDuplicate) {
        existingSkus.add(skuID);
        continue;
      }
      newMappings.push({
        supplierID: parseInt(formData.supplierID),
        supplierName: suppliersForName[formData.supplierID],
        skuMasterID: skuIDNum,
        skuMasterName: sku[skuIDNum],
        supplierSKUMappingID: 0,
        isActive: true,
        createdBy: tokenService.getUserIDFromToken(),
        createdDate: new Date().toISOString(),
      });
    }
    if (existingSkus.size > 0) {
      alert.error(`These SKUs already exist: ${Array.from(existingSkus).map(id => sku[id]).join(', ')}`);
    }

    if (newMappings.length > 0) {
      setSupplierSKUMappingData(prev => [...prev, ...newMappings]);
      alert.success("Data added successfully");
      setFormdata({
        ...formData,
        supplierID: 0,
        budgetcodeID: 0,
        skuCategoryID: 0,
        skuMasterID: [],
      });
      setSelectedOptions([]);
    }
  }
  async function SaveSupplierSKUMapping() {
    if (SupplierSKUMappingData.length === 0) {
      alert.error("No data to save.");
      return;
    }
    const formattedData = SupplierSKUMappingData.map(item => ({
      SupplierID: item.supplierID,
      SKUMasterID: item.skuMasterID,
      IsActive: item.isActive,
      CreatedBy: item.createdBy,
      CreatedDate: item.createdDate,
    }));

    const response = await services.SaveSupplierSKUMapping(formattedData);

    if (response.statusCode === "Success") {
      alert.success(response.message);
      navigate('/app/SupplierSkuMapping/listing');
      setSupplierSKUMappingData([]);
    } else {
      alert.error(response.message);
    }
  }

  function handleClearData() {
    setSupplierSKUMappingData([]);
    setOpenDeleteDialog1(false);
  }

  const handleDialogClose = () => {
    setOpenDeleteDialog1(false);
  };

  const handleDialogOpen = () => {
    setOpenDeleteDialog1(true);
  }

  const groupedData = SupplierSKUMappingData.reduce((acc, item) => {
    const supplierKey = item.supplierName;
    if (!acc[supplierKey]) {
      acc[supplierKey] = {
        supplierName: item.supplierName,
        skuMasterNames: [],
      };
    }
    acc[supplierKey].skuMasterNames.push(item.skuMasterName)
    return acc;
  }, {});

  const tableData = Object.values(groupedData).map(group => ({
    supplierName: group.supplierName,
    skuMasterNames: group.skuMasterNames.join(', ')
  }));

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader
            onClick={handleClick}
          />
        </Grid>
      </Grid>
    )
  }
  return (
    <Page
      className={classes.root}
      title=" Supplier SKU Mapping"
    >
      <LoadingComponent />
      <Container maxWidth={false}>
        <Formik
          initialValues={{
            groupID: formData.groupID,
            factoryID: formData.factoryID,
            supplierID: formData.supplierID,
            budgetcodeID: formData.budgetcodeID,
            skuCategoryID: formData.skuCategoryID,
            skuMasterID: formData.skuMasterID
          }}
          validationSchema={
            Yup.object().shape({
              groupID: Yup.number().required('Group required').min("1", 'Group required'),
              factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
              supplierID: Yup.number().required('Supplier required').min("1", 'Supplier required'),
              budgetcodeID: Yup.number().required('Account Code Name required').min("1", 'Account Code Name required'),
              skuCategoryID: Yup.number().required('SKU Category required').min("1", 'SKU Category required'),
              skuMasterID: Yup.array().nullable().required('SKU required').min("1", 'SKU required')
            })
          }
          onSubmit={handleAdd}
          enableReinitialize
        >
          {({
            errors,
            handleSubmit,
            touched,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box mt={0}>
                <Card>
                  <CardHeader
                    title={cardTitle(" Supplier SKU Mapping")}
                  />
                  <PerfectScrollbar>
                    <Divider />
                    <CardContent style={{}}>
                      <Grid container spacing={3}>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="groupID">
                            Group *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.groupID && errors.groupID)}
                            helperText={touched.groupID && errors.groupID}
                            fullWidth
                            name="groupID"
                            size='small'
                            onChange={(e) => handleChange(e)}
                            value={formData.groupID}
                            variant="outlined"
                            InputProps={{
                              readOnly: !permissionList.isGroupFilterEnabled,
                            }}
                          >
                            <MenuItem value="0">--Select Group--</MenuItem>
                            {generateDropDownMenu(groupArray)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="factoryID">Factory *</InputLabel>
                          <TextField select
                            error={Boolean(touched.factoryID && errors.factoryID)}
                            helperText={touched.factoryID && errors.factoryID}
                            fullWidth
                            size='small'
                            name="factoryID"
                            onChange={(e) => handleChange(e)}
                            value={formData.factoryID}
                            variant="outlined"
                            id="factoryID"
                            InputProps={{
                              readOnly: !permissionList.isFactoryFilterEnabled ? true : false
                            }}
                          >
                            <MenuItem value="0">--Select Factory--</MenuItem>
                            {generateDropDownMenu(factories)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="supplierID">
                            Supplier
                          </InputLabel>
                          <Autocomplete
                            id="supplierID"
                            options={suppliersAuto || []}
                            getOptionLabel={(option) => option?.supplierName || "Unnamed Supplier"}
                            onChange={(e, value) => handleSearchDropdownChangeFieldsSupplier(value, e)}
                            value={
                              suppliersAuto?.find(
                                (option) => option.supplierID === formData.supplierID
                              ) || null
                            }
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                name="supplierID"
                                fullWidth
                                size="small"
                                placeholder="--Select Supplier--"
                                error={Boolean(touched.supplierID && errors.supplierID)}
                                helperText={touched.supplierID && errors.supplierID}

                              />
                            )}
                          />
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="budgetcodeID">
                            Account Code Name *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.budgetcodeID && errors.budgetcodeID)}
                            helperText={touched.budgetcodeID && errors.budgetcodeID}
                            fullWidth
                            name="budgetcodeID"
                            size='small'
                            onChange={(e) => handleChange(e)}
                            value={formData.budgetcodeID}
                            variant="outlined"
                            id="budgetcodeID"
                            InputProps={{
                              readOnly: !permissionList.isFactoryFilterEnabled,
                            }}
                          >
                            <MenuItem value="0">--Select Account Code Name--</MenuItem>
                            {generateDropDownMenu(budgetCodes)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="skuCategoryID">
                            SKU Category *
                          </InputLabel>
                          <TextField select
                            error={Boolean(touched.skuCategoryID && errors.skuCategoryID)}
                            helperText={touched.skuCategoryID && errors.skuCategoryID}
                            fullWidth
                            name="skuCategoryID"
                            size='small'
                            onChange={(e) => handleChange(e)}
                            value={formData.skuCategoryID}
                            variant="outlined"
                          >
                            <MenuItem value="0">--Select SKU Category--</MenuItem>
                            {generateDropDownMenu(skuCategory)}
                          </TextField>
                        </Grid>
                        <Grid item md={4} xs={12}>
                          <InputLabel shrink id="skuMasterID">
                            SKU *
                          </InputLabel>
                          <CustomMultiSelect
                            error={Boolean(touched.skuMasterID && errors.skuMasterID)}
                            helperText={touched.skuMasterID && errors.skuMasterID}
                            items={skuArray}
                            getOptionLabel={getOptionLabel}
                            getOptionDisabled={getOptionDisabled}
                            selectedValues={selectedOptions}
                            placeholder="--Select SKU--"
                            selectAllLabel="Select All"
                            onToggleOption={handleToggleOption}
                            onClearOptions={handleClearOptions}
                            onSelectAll={handleSelectAll}
                          />
                        </Grid>
                      </Grid>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          type="submit"
                          variant="contained"
                        >
                          ADD
                        </Button>
                      </Box>
                    </CardContent>
                    {SupplierSKUMappingData.length > 0 && (
                      <CardContent style={{}}>
                        <Box minWidth={1000}>
                          <MaterialTable
                            title="Supplier SKU Mapping"
                            columns={[
                              { title: 'Supplier', field: 'supplierName' },
                              { title: 'SKUs', field: 'skuMasterNames' },
                            ]}
                            data={tableData}
                            options={{
                              exportButton: false,
                              showTitle: false,
                              headerStyle: { textAlign: "left", height: '1%', paddingLeft: '1rem', paddingRight: '1rem' },
                              cellStyle: { textAlign: "left" },
                              columnResizable: false,
                              actionsColumnIndex: -1,
                            }}
                            actions={[{
                              icon: () => <CloseIcon style={{ color: 'red' }} />,
                              tooltip: 'Remove this row',
                              onClick: (_, rowData) => {
                                const supplierToDelete = rowData.supplierName;
                                const updatedData = SupplierSKUMappingData.filter(item => item.supplierName !== supplierToDelete);
                                setSupplierSKUMappingData(updatedData);
                                alert.success("Data removed successfully");
                              },
                            }]}
                          />
                        </Box>
                        <Box display="flex" justifyContent="flex-end" p={2} gridColumnGap={4}>
                          <Button
                            color="primary"
                            type="button"
                            variant="outlined"
                            onClick={handleDialogOpen}
                            style={{ color: 'red', borderColor: 'red' }}
                          >
                            Clear
                          </Button>
                          <Button
                            color="primary"
                            type="button"
                            variant="contained"
                            onClick={SaveSupplierSKUMapping}
                          >
                            Save
                          </Button>
                        </Box>
                      </CardContent>
                    )}
                  </PerfectScrollbar>
                </Card>
              </Box>
            </form>
          )}
        </Formik>
        <Dialog open={openDeleteDialog} onClose={handleCancelDelete}>
          <DialogTitle>Confirm Deletion</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete this item?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancelDelete} color="primary">
              No
            </Button>
            <Button onClick={handleConfirmDelete} color="secondary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog open={openDeleteDialog1} onClose={handleDialogClose}>
          <DialogTitle>Confirm Clear table</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to Clear Table data?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose} color="primary">
              No
            </Button>
            <Button onClick={handleClearData} color="secondary">
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Page >
  );
}
